import { Stack, StackProps } from "@mui/material";
import React from "react";

export type SHStackProps = StackProps;
export const SHStack = React.forwardRef(
  (props: SHStackProps, ref): JSX.Element => <Stack ref={ref} {...props} />,
);
